import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { CALYPSO_DARK, OZ_DARK, THUNDERDOME_DARK, MARIGOLD_DARK, SORBET_DARK } from 'HubStyleTokens/colors';
export const ProductLineToColor = {
  [MARKETING]: CALYPSO_DARK,
  [SALES]: OZ_DARK,
  [SERVICE]: THUNDERDOME_DARK,
  [OPERATIONS]: MARIGOLD_DARK,
  [CMS]: SORBET_DARK
};